import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { bufferObjectToArrayBuffer, connLink, generateId } from 'src/global';
import { Buffer } from "buffer";
import { FileUpload } from 'node_js/models/tables/file-upload.model';
import { Observable } from 'rxjs';
import { FileUploadComplete } from 'node_js/models/business/lab/file-upload-complete';
import { DomSanitizer } from '@angular/platform-browser';

//In production, this object is a lot more complicated, and file is nested inside of other object
export interface TestObj {
  id: number,
  name: string
  testObjFiles: TestObjFile[];
}
export interface TestObjFile {
  id: string;
  file: File;
  value: string;
  name: string;
  //Other stuff
}
@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {
  }

  async getFile(fileUpload: FileUpload) {
    return new Promise<void>(async (resolve, reject) => {

      this.http.post(connLink + "/getFile", { fileUpload }, { responseType: 'blob' as 'json' }).subscribe(
        (response: any) => {
          console.log(response)
          let dataType = response.type;
          let binaryData = [];
          binaryData.push(response);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileUpload.name)
            downloadLink.setAttribute('download', fileUpload.name);
          document.body.appendChild(downloadLink);
          downloadLink.click();
        }
      )

    })
  }


  convertFileUploadCompleteToBlob(iconFileUploadComplete: FileUploadComplete, skipArrayBufferConversion: boolean = false) {
    let nodeBuffer = iconFileUploadComplete.buffer;

    // Convert Node.js Buffer to ArrayBuffer
    // Convert Node.js Buffer to ArrayBuffer
    let arrayBuffer = nodeBuffer;

    // Robust Check: Inspect the data type at runtime instead of relying solely on the flag.
    if (nodeBuffer instanceof ArrayBuffer || nodeBuffer instanceof Uint8Array) {
      arrayBuffer = nodeBuffer;
    }
    // If it's not already binary, and we aren't forced to skip conversion, convert it from the Buffer object
    else if (skipArrayBufferConversion == false) {
      arrayBuffer = bufferObjectToArrayBuffer(nodeBuffer);
    }

    // Determine MIME type from file object if available, otherwise infer from filename
    let mimeType = "image/png"; // Default fallback
    if (iconFileUploadComplete.file && iconFileUploadComplete.file.type) {
      mimeType = iconFileUploadComplete.file.type;
    } else if (iconFileUploadComplete.fileUpload && iconFileUploadComplete.fileUpload.name) {
      const fileName = iconFileUploadComplete.fileUpload.name.toLowerCase();
      if (fileName.endsWith('.svg')) {
        mimeType = 'image/svg+xml';
      } else if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')) {
        mimeType = 'image/jpeg';
      } else if (fileName.endsWith('.png')) {
        mimeType = 'image/png';
      } else if (fileName.endsWith('.gif')) {
        mimeType = 'image/gif';
      } else if (fileName.endsWith('.webp')) {
        mimeType = 'image/webp';
      }
    }

    // Convert ArrayBuffer to Blob
    const blob = new Blob([arrayBuffer], { type: mimeType });

    // Generate URL
    let imageUrl = URL.createObjectURL(blob);

    let sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl(imageUrl);

    iconFileUploadComplete.srcUrl = sanitizedUrl;
  }

  getFileFromGetRequest(filename: string): Observable<HttpResponse<Blob>> {

    const headers = new HttpHeaders();
    headers.append('Accept', 'application/octet-stream');

    return this.http.get(`${connLink}/getFileFromGetRequest/${filename}`, {
      headers: headers,
      responseType: 'blob',  // Expect the response as Blob
      observe: 'response'     // Observe the entire response (body + headers)
    });
  }

  async uploadFile(file: File) {
    return new Promise<void>(async (resolve, reject) => {

      //const base64 = await this.getBase64(file);
      const formData = new FormData();
      formData.append("test", JSON.stringify({ testObj: 1234 }))

      formData.append("files", file, file.name);

      //console.log(base64)
      this.http.post(connLink + "/uploadFiles", formData, {

      }).subscribe(
        (response: any) => {
          console.log("response", response);
          resolve();
        },
        (errorObj) => {
          console.log("error", errorObj);
          reject();
        })

    })



  }



  async deleteFiles(fileUploads: FileUpload[]) {
    return new Promise<void>(async (resolve, reject) => {

      this.http.post(connLink + "/deleteFiles", { fileUploads }, {

      }).subscribe(
        (response: any) => {
          console.log("response", response);
          resolve();
        },
        (errorObj) => {
          console.log("error", errorObj);
          reject();
        })

    })
  }

  async deleteAllFilesInDirectory(directory: string) {
    return new Promise<void>(async (resolve, reject) => {

      this.http.post(connLink + "/deleteAllFilesInDirectory", { directory }, {

      }).subscribe(
        (response: any) => {
          console.log("response", response);
          resolve();
        },
        (errorObj) => {
          console.log("error", errorObj);
          reject();
        })

    })
  }

  createFileUpload(path: string, name: string, userId: string) {
    let fileUpload: FileUpload = {
      id: generateId(),
      path,
      name,
      createdAt: Date.now().toString(),
      filePathCode: generateId(),
      clonedPath: ""
    }
    return fileUpload;
  }

}
